import {
  SidebarCardKey,
  SidebarCardRef,
  SidebarCardType,
} from '../conversationSidebar.types';

const SIDEBAR_CARD_TYPES: readonly SidebarCardType[] = [
  'static',
  'native',
  'custom',
];

const isSidebarCardType = (value: string): value is SidebarCardType =>
  (SIDEBAR_CARD_TYPES as readonly string[]).includes(value);

/** Builds the namespaced, collision-free key for a card in the flat model. */
export const cardKey = ({ cardType, cardId }: SidebarCardRef): SidebarCardKey =>
  `${cardType}:${cardId}`;

/**
 * Parses a namespaced card key back into its {@link SidebarCardRef}. Returns
 * `null` for a malformed key — one with no `:` separator or an unknown
 * namespace — so callers can ignore it rather than acting on a garbage ref.
 */
export const parseCardKey = (key: string): SidebarCardRef | null => {
  const separator = key.indexOf(':');
  if (separator < 0) {
    return null;
  }
  const cardType = key.slice(0, separator);
  if (!isSidebarCardType(cardType)) {
    return null;
  }
  return {
    cardType,
    cardId: key.slice(separator + 1),
  };
};
